import React, { useEffect, useState } from 'react';
import { Box, Paper, Typography } from '@mui/material';
import LeadsBoard from './leads/LeadsBoard';
import { crm, inr } from '../../api/crm';
import { useSales } from '../../context/SalesContext';

const Stat = ({ label, value, color }) => (
  <Paper variant="outlined" sx={{ p: 1.5, borderRadius: 2, flex: '1 1 150px', minWidth: 0 }}>
    <Typography variant="caption" color="text.secondary" display="block" noWrap>{label}</Typography>
    <Typography variant="h6" fontWeight={700} color={color}>{value}</Typography>
  </Paper>
);

// Webinars: webinar registrants and buyers the viewer may work. Same list, filters and
// ownership as app leads (a person assigned on the webinar side is the same person on
// the app side). The weekly numbers are company-level, so only leaders and admins see them.
const Webinars = () => {
  const sales = useSales();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    if (!sales.isManager) return;
    crm('webinars/stats', { query: { period: 'week' } }).then(setStats).catch(() => setStats(null));
  }, [sales.isManager]);

  return (
    <Box>
      {sales.isManager && stats && (
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 1.5 }}>
          <Stat label="Main webinar registrations (this week)" value={(stats.main_webinar_registrations || 0).toLocaleString('en-IN')} color="primary.main" />
          <Stat label="App webinar registrations (this week)" value={(stats.app_webinar_registrations || 0).toLocaleString('en-IN')} color="info.main" />
          <Stat label="Webinar revenue (this week)" value={inr(stats.total_revenue)} color="success.main" />
        </Box>
      )}
      <LeadsBoard segment="webinar" />
    </Box>
  );
};

export default Webinars;
